<template>
  <div
    class="sso-login"
    v-loading="waitLoading"
    element-loading-text="跳转登录中..."
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <!-- 这里是第三方跳转（用户无感知） Ticket 登录中转页面 -->
    <p>{{ errorMsg }}</p>
  </div>
</template>

<script>
import { clientName } from '../settings'

export default {
  name: 'ssoLogin',

  data() {
    return {
      waitLoading: false,
      errorMsg: ''
    }
  },

  created() {
    // 获取 URL 中登录所需参数
    const { ticket, uid } = this.$route.query
    if (!ticket || !uid) {
      this.errorMsg = '请求参数无效，请重新登录！'
      return
    }
    
    this.loginByTicket({ ticket, uid })
  },

  methods: {
    loginByTicket({ ticket, uid }) {      
      this.waitLoading = true;
      this.$api
        .loginByTicket({ ticket, uid })
        .then(res => {
          this.waitLoading = false;

          if (!res.data?.meta?.success) {
            this.loginFail(res.data.meta.message, res.data.location)
            return
          }
          this.loginSuccess(res.data)          
        })
        .catch((err) => {
          console.error('loginByTicket', err)
          this.errorMsg = '网络连接错误，请检查您的网络！'
        });
    },

    loginFail(message, path) {
      this.$message({ message, type: "error" })
      if (path) {
        location.href = path + `?clientName=${clientName}&callbackUrl=${location.origin}`
      } else {
        this.$router.push('/login')
      }
    },

    loginSuccess(data) {
      const { user, jgdm, role, qymc } = data.data
      // 存储登录信息到本地
      localStorage.setItem("user", user)
      localStorage.setItem("jgdm", jgdm)
      localStorage.setItem("role", role)
      localStorage.setItem("qymc", qymc)
      // 根据角色进行导航跳转
      if (role == "M") {
        this.$router.push("/adminIndex");
      } else {
        this.$router.push("/kbxmList");
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sso-login {
  padding: 100px 0;
  text-align: center;
}
</style>